import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Consult } from '../../interfaces';

@Component({
  selector: 'school-teleconsult-payment-detail-popup',
  templateUrl: './teleconsult-payment-detail-popup.component.html',
})
export class TeleconsultPaymentDetailPopupComponent implements OnInit {
  paymentStatus: string;
  
  constructor(
    public dialogRef: MatDialogRef<TeleconsultPaymentDetailPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public consult: Consult
  ) {}

  ngOnInit(): void {
    console.log('pay', this.consult);

    if (this.consult.payment.status) {
      this.paymentStatus = this.consult.payment.status.toUpperCase();
    }
  }
}
